import React from 'react';
import { Badge, BadgeText } from '@/components/gluestack/badge';
import { useIsStagingApi } from '@/hooks/useApiHostPrefix';

export function StagingApiBadge() {
  const isStaging = useIsStagingApi();

  if (!isStaging) return null;

  return (
    <Badge variant="solid" action="warning" size="md" className="rounded-md">
      <BadgeText bold>Staging</BadgeText>
    </Badge>
  );
}
